import { Changelog } from './changelog.entities';

/* Add new entries here manually when updating changelog */
export const changelog: Changelog = [
  {
    title: 'MDU support in Delivery Portal (Sweden)',
    body: `<div><p>
          Delivery Portal now supports Multi-Dwelling Unit (MDU) installations for Swedish densification projects.
          </p><ul>
          <li>View MDU installations and their current installation/report status in the Delivery Portal</li>
          <li>Mark a whole section as non-applicable when self-inspections are done on another report</li>
          <li>Updated reporting flow divided on delivery objects and delivery points</li>
          <li>New feature to mark as &quot;BOM&quot; for points that cannot be installed</li>
          <li>IFS needs to be manually imported to be shown in the first version</li>
          </ul><p><strong>Internal users only:</strong></p><ul>
          <li>To fetch MDU project to DP, go to Delivery overview, write the new IFS in the search bar and click &quot;Create IFS&quot;</li>
          </ul></div>`,
    date: '2026-10-27',
    federatedOnly: true,
  },
  {
    title: 'Reports overview in Rollout Progress',
    body: `<div><p>
          A new reports overview makes it easier to follow construction progress in Rollout Progress.
          </p><ul>
          <li>View reportable spans and points with their current report status</li>
          <li>Filter by report type, search by name, and hide completed reports</li>
          <li>Select a row to locate the related item on the map</li>
          </ul>`,
    date: '2026-09-08',
    imageUrl: 'assets/images/changelog/construction-progress-table.png',
    imageAlt: 'Construction progress reports table',
  },
  {
    title: 'Clear color for existing span',
    body: `<div><p>
          Spans in Rollout Progress that are marked as already existing are now yellow in Rollout Progress and it is not possible to report on them.
          `,
    date: '2026-08-19',
  },
  {
    title: 'New features released in DeliveryPortal',
    body: `<div><p><ul>
          <li>Guides and instruction videos</li>
          <li>Order status in Roll out progress synced automatically</li>
          <li>(FINLAND ONLY) Plot design signing</li>
          <li>(FINLAND ONLY) Contractor can complete an installation report, marks customer as formally commissioned</li>
          </ul>`,
    date: '2026-06-16',
  },
  {
    title: 'New features released in DeliveryPortal',
    body: `<div><p><ul>
          <li>Generate and download reports in Installation Reporting</li>
          <li>Generate and download of reports in Rollout Progress</li>
          <li>(SWEDEN ONLY) Port connection check (auto discovery) in Commissioning</li>
          <li>(FINLAND ONLY) Updated setup in pre-installation, choose of network type and CPE device to reduce incorrect data inputs.</li>
          </ul>`,
    date: '2026-04-20',
    videoUrl:
      'https://www.youtube.com/embed/OQgTPE_xxDs?si=bzkJCnU9a8JixN91%22',
  },
];
